import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  align-self: flex-start;
  gap: ${props => props.theme.gap(1, 'row')};
`;

export const Label = styled.p`
  color: ${props => props.theme.registrationNumber.text};
  font-size: ${props => props.theme.rem(16)};
  font-family: 'IntervalNextMed', sans-serif;
`;

export const RegistrationValue = styled.p`
  color: ${props => props.theme.registrationNumber.text};
  font-size: ${props => props.theme.rem(14)};
`;

export const TooltipContent = styled.span`
  display: block;
`;
